import { render } from "./Dialog.vue?vue&type=template&id=9b15be06&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=9b15be06&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9b15be06"

export default script